const QiDao = [
  'fantom-bifi-maxi',
  'scream-eth',
  'scream-wbtc',
  'scream-ftm',
  'scream-link',
  'scream-dai',
  'aave-wavax',
  'aavev3-op-wbtc',
  'aavev3-op-dai',
  'aavev3-op-eth',
  'curve-op-f-wsteth',
];

const Insurace = [
  'bsc',
  'avax',
  'celo',
  'cronos',
  'fantom',
  'harmony',
  'moonriver',
  'polygon',
  'ethereum',
];

const Nexus = [
  'bsc',
  'avax',
  'heco',
  'polygon',
  'fantom',
  'harmony',
  'arbitrum',
  'celo',
  'moonriver',
  'cronos',
  'fuse',
  'metis',
  'aurora',
  'moonbeam',
  'optimism',
  'ethereum',
];

export { QiDao, Insurace, Nexus };
